// extracted by mini-css-extract-plugin
export default {"wrapper":"StrategiesTreeModel_wrapper__J4cpc"};